"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStoreFrontByAddress = exports.getStorefrontsForNetwork = exports.STOREFRONTS = void 0;
exports.STOREFRONTS = [
    {
        address: '0x495f947276749ce646f68ac8c248420045cb7b5e',
        networkId: 1,
        name: 'OpenSea',
        spec: 1155,
    },
    {
        address: '0x60f80121c31a0d46b5279700f9df786054aa5ee5',
        networkId: 1,
        name: 'Rarible',
        spec: 721,
    },
    {
        address: '0xf6793da657495ffeff9ee6350824910abc21356c',
        networkId: 1,
        name: 'Rarible',
        spec: 721,
    },
    {
        address: '0xc9154424b823b10579895ccbe442d41b9abd96ed',
        networkId: 1,
        name: 'Rarible',
        spec: 721,
    },
    {
        address: '0xd07dc4262bcdbf85190c01c996b4c06a461d2430',
        networkId: 1,
        name: 'Rarible',
        spec: 1155,
    },
    {
        address: '0xb66a603f4cfe17e3d27b87a8bfcad319856518b8',
        networkId: 1,
        name: 'Rarible',
        spec: 1155,
    },
    {
        address: '0xb932a70a57673d89f4acffbe830e8ed7f75fb9e0',
        networkId: 1,
        name: 'SuperRare',
        spec: 721,
    },
    {
        address: '0x41a322b28d0ff354040e2cbc676f0320d8c8850d',
        networkId: 1,
        name: 'SuperRare',
        spec: 721,
    },
    {
        address: '0x2a46f2ffd99e19a89476e2f62270e0a35bbf0756',
        networkId: 1,
        name: 'Makerspace',
        spec: 721,
    },
    {
        address: '0x2963ba471e265e5f51cafafca78310fe87f8e6d1',
        networkId: 1,
        name: 'Makerspace',
        spec: 721,
    },
    {
        address: '0x6c424c25e9f1fff9642cb5b7750b0db7312c29ad',
        networkId: 1,
        name: 'AsyncArt',
        spec: 721,
    },
    {
        address: '0xb6dae651468e9593e4581705a09c10a76ac1e0c8',
        networkId: 1,
        name: 'AsyncArt',
        spec: 721,
    },
    {
        address: '0xc143bbfcdbdbed6d454803804752a064a622c1f3',
        networkId: 1,
        name: 'AsyncArtBlueprints',
        spec: 721,
    },
    {
        address: '0x3b3ee1931dc30c1957379fac9aba94d1c48a5405',
        networkId: 1,
        name: 'Foundation',
        spec: 721,
    },
    {
        address: '0xabb3738f04dc2ec20f4ae4462c3d069d02ae045b',
        networkId: 1,
        name: 'Known Origin',
        spec: 721,
    },
    {
        address: '0xfbeef911dc5821886e1dda71586d90ed28174b7d',
        networkId: 1,
        name: 'Known Origin',
        spec: 721,
    },
    {
        address: '0x4d232cd85294acd53ec03f4a57f57888c9ea1946',
        networkId: 1,
        name: 'Metamorphosis',
        spec: 721,
    },
    {
        address: '0x99a9b7c1116f9ceeb1652de04d5969cce509b069',
        networkId: 1,
        name: 'ArtBlocks',
        spec: 721,
    },
    {
        address: '0xa7d8d9ef8d8ce8992df33d8b8cf4aebabd5bd270',
        networkId: 1,
        name: 'ArtBlocks',
        spec: 721,
    },
    {
        address: '0x2953399124f0cbb46d2cbacd8a89cf0599974963',
        networkId: 137,
        name: 'OpenSea',
        spec: 1155,
    },
    {
        address: '0xb0ea149212eb707a1e5fc1d2d3fd318a8d94cf05',
        name: 'Rarible',
        spec: 721,
    },
    {
        address: '0x6a94ac200342ac823f909f142a65232e2f052183',
        name: 'Rarible',
        spec: 1155,
    },
];
function getStorefrontsForNetwork(networkId) {
    return exports.STOREFRONTS.filter(function (storefront) { return storefront.networkId === networkId || storefront.networkId === undefined; });
}
exports.getStorefrontsForNetwork = getStorefrontsForNetwork;
function getStoreFrontByAddress(networkId, address) {
    return getStorefrontsForNetwork(networkId).find(function (storefront) { return storefront.address === address; });
}
exports.getStoreFrontByAddress = getStoreFrontByAddress;
